import { useMutation, useQueryClient } from '@tanstack/react-query';
import { RoleEntitySchema, type CreateRoleInput, type RoleEntity } from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export function useCreateRole() {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<RoleEntity, unknown, CreateRoleInput>({
    mutationFn: (input) => client.post<RoleEntity>('/roles', input, {}, RoleEntitySchema),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['roles', 'admin-list'] });
      qc.invalidateQueries({ queryKey: ['roles', 'list'] });
    },
  });
}
